import { useToken } from "@hightouch/htui";
import { type Variants, useReducedMotion } from "motion/react";
import { useMemo } from "react";

type Options = {
  animationDelay?: number;
  shimmerColors?: [string, string];
};

export const useShimmer = ({
  animationDelay = 0,
  shimmerColors = ["base.background", "base.divider"],
}: Options = {}): Variants => {
  const [restColor, peakColor] = useToken("colors", shimmerColors);
  const shouldReduceMotion = useReducedMotion();

  const variants: Variants = useMemo(() => {
    if (shouldReduceMotion) {
      return {
        initial: { backgroundColor: peakColor },
        animate: { backgroundColor: peakColor },
      };
    }
    return {
      // Resting fill so bars with a stagger delay are visible immediately —
      // `transition.delay` defers the whole animation, not just its phase.
      initial: { backgroundColor: restColor },
      animate: {
        backgroundColor: [restColor, peakColor, restColor],
        transition: {
          delay: animationDelay,
          duration: 1,
          repeat: Infinity,
          ease: [0.4, 0, 0.6, 1],
        },
      },
    };
  }, [restColor, peakColor, animationDelay, shouldReduceMotion]);

  return variants;
};
